type OkTuple<T> = Readonly<[T, null]>

type OkProps<T> = Readonly<{ error: null; data: T }>

export type Ok<T> = OkTuple<T> & OkProps<T>

/**
 * Returns an object representing a successful result with the given data.
 * @template T The type of the data.
 * @param {T} data The data to include in the result.
 * @returns {Ok<T>} An object representing a successful result with the given data.
 */
export const ok = <T>(data: T): Ok<T> => {
  return {
    error: null,
    data,
    0: data,
    1: null,
    length: 2,
    [Symbol.iterator]: function* () {
      yield data
      yield null
    },
  } as Ok<T>
}
